<template>
    <form @submit.prevent="submitFormAgent">
        <h6 class="heading-small text-muted mb-4">ข้อมูลส่วนตัว</h6>
        <div class="row">
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span>  ชื่อ-สกุลตัวแทนจำหน่าย
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        placeholder="ชื่อ-สกุลตัวแทนจำหน่าย"
                        :class="{ 'is-invalid': submitForm && $v.agent.name.$error }"
                        v-model="agent.name"
                    />
                    <label
                        v-if="submitForm && !$v.agent.name.required"
                        class="invalid-feedback"
                    >กรุณากรอกชื่อ-สกุลตัวแทนจำหน่าย</label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label>
                        <span class="text-danger">*</span> อีเมล
                    </label>
                    <input
                        :disabled="!this.$USER_LOGIN.get().isShippop"
                        type="text"
                        class="form-control"
                        placeholder="อีเมล"
                        :class="{ 'is-invalid': submitForm && $v.agent.email.$error }"
                        v-model="agent.email"
                    />
                    <label v-if="submitForm && !$v.agent.email.email" class="invalid-feedback">
                        รูปแบบอีเมลไม่ถูกต้อง
                    </label>
                    <label v-if="submitForm && !$v.agent.email.required" class="invalid-feedback">
                        กรุณากรอกอีเมล
                    </label>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="form-group">
                    <label> 
                        <a class="a-tag color-tag" @click="changePassword">{{ (switchPassword) ? 'รหัสผ่านใหม่': 'เปลี่ยนรหัสผ่าน' }}</a>
                    </label>
                    <input
                        :disabled="!switchPassword"
                        autocomplete="on"
                        type="password"
                        class="form-control"
                        placeholder="รหัสผ่าน"
                        v-model="agent.password"
                    />
                </div>
            </div>
        </div>
        <template v-if="this.$USER_LOGIN.get().isShippop">
            <h6 class="heading-small text-muted mb-4">ข้อมูลวอเล็ท</h6>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                    <b-form-checkbox
                        v-model="agent.walletOpen"
                        :value="true"
                        :unchecked-value="false"
                        :disabled="agent.forceUseWallet"
                    >
                        เปิดใช้งาน Wallet
                    </b-form-checkbox>
                    </div>
                </div>
                <template v-if="this.agent.walletOpen">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>
                                pgw_public_key
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="pgw_public_key"
                                v-model="agent.pgwPublicKey"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>
                                pgw_private_key
                            </label>
                            <input
                                type="text"
                                class="form-control"
                                placeholder="pgw_private_key"
                                v-model="agent.pgwPrivateKey"
                            />
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <hr class="my-4" />
        <BranceSale 
            :personal="agent.sale"
        />
        <hr class="my-4" />
        <BrancePayment 
            :personal="agent" 
            :disablePayment="!this.$USER_LOGIN.get().isShippop"
            @setWallet="setWallet($event)"
        />
        <FormAgentTax
            ref="agentTax"
            :agent="agent"
        />
        <hr class="my-4" />
        <div class="mt-4 w-100 text-right">
            <b-button variant="secondary" @click="resetForm()">กรอกใหม่</b-button>
            <b-button 
                type="submit" 
                variant="info"
                v-if="auth0RoleUsage('agentmanageedit')"
            >บันทึก</b-button>
        </div>
    </form>
</template>

<script>
import {
  required,
  email,
} from "vuelidate/lib/validators"
import FormAgentTax from "./FormAgentTax.vue"
import BrancePayment from "../branceNew/BrancePayment.vue"
import BranceSale from "../branceNew/BranceSale.vue"
import { updateAgent, updateReceiptInfoAgent } from "@/axios/agent.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import { auth0RoleUsage } from "@/helpers/auth0"

export default {
    props: {
        agent: Object
    },
    data() {
        return {
            submitForm: false,
            switchPassword: false,
            auth0RoleUsage: auth0RoleUsage,
        };
    },
    validations() {
        return {
            agent: {
                name: { required },
                email: { required, email },
            }
        };
    },
    components: { 
        FormAgentTax, 
        BrancePayment,
        BranceSale
    },
    methods:{
        submitFormAgent(){
            if( this.$USER_LOGIN.get().isSuperadmin ){
                this.$refs.agentTax.submitFormAgentTax();
                this.submitForm = true;
                this.$v.agent.$touch();
                if (this.$v.agent.$invalid || this.$refs.agentTax.$v.agent.$invalid ) {
                    return false
                }
            }

            this.updateDataAgent();
        },
        updateDataAgent(){
            this.agent.busy = true
            updateAgent( this.agent , this.$route.params.Id ).then( (res) => {
                if( res ){
                    this.updateReceiptInfo();
                }
            }).catch(error => {
                this.agent.busy = false
                showErrorModal( error )
            })
        },
        updateReceiptInfo(){
            updateReceiptInfoAgent(this.agent, this.$route.params.Id ).then( (res) => { 
                if( res ){
                    this.agent.busy = false
                    showSuccessModal('บันทึกข้อมูลข้อมูลสำเร็จ')
                }
            }).catch(error => {
                this.agent.busy = false
                showErrorModal( error )
            })
        },
        changePassword(){
            this.switchPassword = !this.switchPassword
        },
        resetForm(){
            Object.keys(this.agent).forEach(key => {
                if( !['name', 'email', 'password', 'pgwPublicKey', 'pgwPrivateKey'].includes(key) ){
                    this.agent[key] = '';
                }
            });
        },
        setWallet( status ){
            this.agent.walletOpen = status
        },
    }
}
</script>